module.exports = __webpack_public_path__ + "img/process-success.30c4acf4.svg";